import { BillingType, InitialDiscount } from '~/components/BillModal/BillClientModal.types';
import { serviceTemplateModel } from '~/models';
import { ContactAccountantAccess, ContactEditMode, ContactModel, ContactStatus } from '~/models/ContactModel';
import { utils } from '~/utils';
export const buildClientContact = (relationship)=>{
    var _relationship_clientContactId, _relationship_buyer_firstName, _relationship_buyer_lastName;
    return new ContactModel({
        id: (_relationship_clientContactId = relationship.clientContactId) !== null && _relationship_clientContactId !== void 0 ? _relationship_clientContactId : relationship.buyer.id,
        createdAt: 0,
        userId: null,
        firstName: (_relationship_buyer_firstName = relationship.buyer.firstName) !== null && _relationship_buyer_firstName !== void 0 ? _relationship_buyer_firstName : '',
        lastName: (_relationship_buyer_lastName = relationship.buyer.lastName) !== null && _relationship_buyer_lastName !== void 0 ? _relationship_buyer_lastName : '',
        companyName: relationship.customer.name,
        email: relationship.buyer.email,
        phone: relationship.buyer.phone,
        isSample: false,
        edit: {
            mode: ContactEditMode.Readonly
        },
        vendorId: relationship.vendor.id,
        version: '',
        accountantAccess: ContactAccountantAccess.NonCandidate,
        status: ContactStatus.Active,
        hasSignedAgreements: false,
        hasPendingProposals: false,
        integrations: [],
        archiveEligibility: {
            type: 'eligible'
        },
        deleteEligibility: {
            type: 'eligible'
        },
        hasDrafts: false
    });
};
export const formatTemplateCost = (template)=>utils.formatDollarAmount(serviceTemplateModel.price(template));
const RESTORED_TEMPLATE_PLACEHOLDER = 'restored-scheduled-charge';
const toDiscountValue = (discount)=>discount == null ? InitialDiscount : {
        type: discount.type(),
        amount: discount.amount().toString()
    };
export const restoredChargeToDisabledItem = (lineItem)=>({
        itemId: lineItem.id,
        type: BillingType.Charge,
        name: lineItem.name,
        note: '',
        disabled: true,
        charge: {
            serviceTemplateId: RESTORED_TEMPLATE_PLACEHOLDER,
            quantity: lineItem.adHocCharge.quantity.toString(),
            rate: lineItem.rate.amount.toString(),
            discount: toDiscountValue(lineItem.adHocCharge.discount)
        }
    });
